// 画面内部のハッシュナビゲーション定数
export const IMPORT_CSV_FORM_HASH = {
  UPLOAD_FILE: "upload-file",
  PREVIEW_FILE: "preview-file",
  IMPORT_DATA: "import-data",
} as const;
export type IMPORT_CSV_FORM_HASH_VALUE =
  (typeof IMPORT_CSV_FORM_HASH)[keyof typeof IMPORT_CSV_FORM_HASH];
